import { UtcDate } from '@/helpers/date';

export default {
  validate: (value, { format }) => {
    return {
      valid: new UtcDate().parse(value, format).isValid(),
      required: true,
    };
  },
  params: ['format'],
  computesRequired: true,
};
